import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const PixelTag = props => {
  const { pixelTagLink: tagLink } = props;
  const pixelStyle = { boderStyle: 'none', width: '1', height: '1' };
  const [pixelDate, setPixelDate] = useState('');
  const [pixelLink, setPixeTag] = useState('');
  useEffect(() => {
    setPixeTag(tagLink);
    setPixelDate(Date.now());
  }, []);

  if (!pixelLink) {
    return null;
  }

  return (
    <div>
      <img style={pixelStyle} alt="" src={`${pixelLink}&time=${pixelDate}`} />
    </div>
  );
};

PixelTag.propTypes = {
  pixelTagLink: PropTypes.string
};

export default PixelTag;
